import type { AppRouteRecordRaw } from "../types/types";

import { RouteNames } from "@/app/router/types/names";
import { Permissions, PermissionGroups } from "@/shared/constants";

const accountHealthRoutes: AppRouteRecordRaw[] = [
  {
    path: "/account-health",
    name: "account-health-parent",
    redirect: "/account-health/summary",
    meta: {
      menuIcon: "lucide:activity",
      menuTitle: "Account Health",
      isMenuParent: true,
      permissions: PermissionGroups.ACCOUNT_HEALTH,
    },
    children: [
      {
        path: "summary",
        name: RouteNames.HEALTH,
        meta: {
          pageKey: "AccountHealth",
          permissions: [Permissions.ACCOUNT_HEALTH],
          title: "Account Health Summary",
          menuTitle: "Summary",
          menuIcon: "lucide:file-text",
        },
        component: () => import("@/pages/AccountHealth/AccountHealth.vue"),
      },
      {
        path: "product-alerts",
        name: RouteNames.ALERTS,
        meta: {
          pageKey: "ProductAlerts",
          permissions: [Permissions.ALERTS],
          title: "Product Alerts",
          menuTitle: "Product Alerts",
          menuIcon: "lucide:bell",
          filters: {
            hide: ["granularity", "dateRange", "comparison"],
          },
        },
        component: () => import("@/pages/AccountHealth/ProductAlerts.vue"),
      },
      {
        path: "/buy-box-intelligence",
        name: RouteNames.BUY_BOX_INTELLIGENCE,
        meta: {
          pageKey: "BuyBoxIntelligence",
          permissions: [Permissions.BUY_BOX_INTELLIGENCE],
          menuTitle: "Jarvis",
          title: "Jarvis - Buy Box Intelligence System",
          menuIcon: "lucide:crosshair",
          filters: {
            show: ["brands", "channels", "products"],
          },
        },
        component: () => import("@/pages/AccountHealth/BuyBoxIntelligence.vue"),
      },
      {
        path: "/brand-protection",
        name: RouteNames.BRAND_PROTECTION,
        meta: {
          pageKey: "BrandProtection",
          permissions: [Permissions.BRAND_PROTECTION],
          menuTitle: "Brand Protection",
          title: "Brand Protection",
          menuIcon: "lucide:shield-check",
        },
        component: () => import("@/pages/AccountHealth/BrandProtection.vue"),
      },
    ],
  },

];

export default accountHealthRoutes;
